import request from '@/utils/request'

let Department_InformationApi = {

  /*科室列表*/
  list(data) {
    return request._post('/shop/plus.department_Information.Index/index', data);
},
/*添加科室*/
add(data) {
    return request._post('/shop/plus.department_Information.Index/add', data);
},
/*修改科室*/
edit(data) {
    return request._post('/shop/plus.department_Information.Index/edit', data);
},
/*删除科室*/
del(data) {
    return request._post('/shop/plus.department_Information.Index/del', data);
},
/*科室详情*/
detail(data) {
  return request._post('/shop/plus.department_Information.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.department_Information.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.department_Information.Setting/getSetting', data, errorback);
    },
}
export default Department_InformationApi;



// WEBPACK FOOTER //
// ./src/api/department_Information.js